<script>
	import { Col, Row, Button, Image } from "sveltestrap";
	import { Splide, SplideSlide } from "@splidejs/svelte-splide";
	import { onMount } from "svelte";
	import {
		damageAreaOptions,
		damageTypeOptions,
	} from "../../../../../utils/options";
	import { issueDetail, imageLightbox } from "../../../../../store/store";

	const child = $issueDetail.exteriorIssues;
	let dataImg = [];
	Object.keys(child).forEach((key) => {
		Object.keys(child[key]).forEach((data) => {
			child[key][data].forEach((url) => {
				dataImg.push({
					url,
					text: key,
				});
			});
		});
	});

	$: image = dataImg;
	$: damageArea = "All";

	const handleChange = (value) => {
		let eachData = $issueDetail.exteriorIssues[value];
		if (value !== "All") {
			let urlImg = [];
			for (const key in eachData) {
				if (eachData.hasOwnProperty(key)) {
					urlImg.push(...eachData[key]);
				}
			}

			dataImg = urlImg.map((url) => {
				return {
					url,
					text: value,
				};
			});
		} else {
			let urlImg = [];
			Object.keys(child).forEach((key) => {
				Object.keys(child[key]).forEach((data) => {
					child[key][data].forEach((url) => {
						urlImg.push({
							url,
							text: key,
						});
					});

					dataImg = urlImg;
				});
			});
		}
	};

	//Lightbox for image
	import Lightbox from "../../../../../components/Lightbox/Lightbox.svelte";

	let modalOpen = false;
	let imageShowingIndex = 0;

	const handleImgClick = (i) => {
		let arrImg = [];
		let img = image.map((url) => {
			arrImg.push(url.url);
		});
		imageLightbox.set([]);
		imageShowingIndex = Number(i);
		modalOpen = true;
		imageLightbox.set(arrImg);
	};
</script>

{#if modalOpen}
	<Lightbox on:click={() => (modalOpen = false)} {imageShowingIndex} />
{/if}

<Col xs={12}>
	<!-- <Splide {options} aria-label="My Favorite Images">
		{#each image as slide, index}
			<SplideSlide>
				<img
					src={slide}
					alt="alt"
					style="width: 100%; height:100%; object-fit: scale-down;"
					class="link"
					on:click={() => handleImgClick(index)}
				/>
			</SplideSlide>
		{/each}
	</Splide> -->
	<Row class="carousel-detail-image mb-4  overflow-auto">
		<Col class="row d-flex pe-1">
			<div class="ps-3 pt-3">
				<h6>Total record: <b>{image.length} image(s)</b></h6>
			</div>
			<div class="ps-3 py-3">
				<div>
					{#each image as { url, text }, index}
						<!-- svelte-ignore a11y-click-events-have-key-events -->
						<div
							class="container-checkbox link"
							style="height:auto; border: 0px !important; padding: 5px !important;
			outline: 0 !important; "
							on:click={() => handleImgClick(index)}
						>
							<Image
								src={url}
								style="width:100%; height:400px; object-fit: scale;"
								alt="vehicle image"
							/>
							<span><b>{text}</b></span>
						</div>
					{/each}
				</div>
			</div>
		</Col>
	</Row>
</Col>
<Col xs={12} class="my-2 ms-2">
	<Col xxl={12} class="my-4">
		<Row class="my-3">
			<Col><span>Damage Area</span></Col>
			<Col xs={9}>
				<div>
					<label
						key={`option-damageArea-5`}
						class="customCheckbox-new ms-2"
					>
						<input
							type="radio"
							name="damageArea"
							value="All"
							class="d-none input"
							on:change={() => handleChange("All")}
							bind:group={damageArea}
						/>
						<span class="customCheckbox-content-new py-1 mb-2">
							All
						</span>
					</label>
					{#each damageAreaOptions as { name, value, label }, key}
						<label
							key={`option-${name}-${key + 1}`}
							class="customCheckbox-new ms-2"
						>
							<input
								type="radio"
								{name}
								{value}
								class="d-none input"
								on:change={() => handleChange(value)}
								bind:group={damageArea}
								disabled={!$issueDetail.exteriorIssues.hasOwnProperty(
									value
								)}
							/>
							<span
								class="{!$issueDetail.exteriorIssues.hasOwnProperty(
									value
								)
									? 'customCheckbox-content-new-disabled'
									: 'customCheckbox-content-new'} py-1 mb-2"
							>
								{label}
							</span>
						</label>
					{/each}
				</div>
			</Col>
		</Row>
		<!-- <Row class="my-3">
			<Col><span>Damage Type</span></Col>
			<Col xs={9}>
				<div>
					{#each damageTypeOptions as { name, value, label }, key}
						<label
							key={`option-${name}-${key + 1}`}
							class="customCheckbox-new ms-2"
						>
							<input
								type="radio"
								id="damageType"
								{name}
								{value}
								class="d-none input"
								on:change={() => handleChangeType(value)}
								bind:group={damageType}
								disabled={!$issueDetail.exteriorIssues[
									damageArea
								].hasOwnProperty(value !== "All")}
							/>
							<span
								class="{!$issueDetail.exteriorIssues[
									damageArea
								].hasOwnProperty(value)
									? 'customCheckbox-content-new-disabled'
									: 'customCheckbox-content-new'} py-1 mb-2"
							>
								{label}
							</span>
						</label>
					{/each}
				</div>
			</Col>
		</Row> -->
	</Col>
</Col>

<style>
	.container-checkbox {
		position: relative;
		float: left;
		width: 50%;
		padding: 5px;
	}

	:global(.carousel-detail-image) {
		border: 0.5px solid gray;
		margin-left: 10px !important;
		margin-right: 10px !important;
		/* padding-left: 10px; */
		border-radius: 0.375rem;
		overflow: hidden;
		height: 600px;
		/* box-shadow: 0px 0px 1px 1px rgba(154, 146, 146, 0.5); */
	}
</style>
